import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { connect, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import IconInvoices from "../iconComponents/IconInvoices";
import { uploadFileAttachment, editContractAttachment } from "../../actions/core";
import { getContractsOutgoing, getContractDrops, setContractDrop, clearContractsOutgoing } from "../../actions/contract";
import { getProjects, clearProject, setProjectDrop } from "../../actions/projects";
import { sendNewInvoice, createInvoiceDraft, sendSavedInvoice, editInvoiceDraft, getInvoice, clearInvoice, clearInvoiceAttachments, getInvoiceWithoutAttachments, toggleInvoiceTab, respondToInvoice, deleteInvoice } from "../../actions/invoices";
import Addfiles from "../common/Addfiles";
import {Redirect} from "react-router-dom";
import {logout} from "../../actions/auth";
import ConfirmationModal from "../common/Modal/ConfirmationModal";
import InvoiceReviewModal from "./InvoiceReviewModal";
import {createMessage} from "../../actions/messages";
import IconTrash from "../iconComponents/IconTrash";

// Client-side-only interim step for GitHub #650 (no upload type restriction existed at
// all before this) -- an allowlist of legitimate business document/image types, not a
// blocklist of dangerous ones (blocking just ".exe" misses .bat/.sh/.scr/.jar/etc). This
// is easily bypassed by a direct API call; the real fix is the server-side check #650
// still tracks.
const ALLOWED_ATTACHMENT_TYPES = "application/pdf,image/jpeg,image/png,image/gif,image/webp,image/tiff,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation,text/plain,text/csv";

export function InvoiceEdit(props) {

    const contracts = useSelector(state => state.contract.contracts);
    const contractDrops = useSelector(state => state.contract.contractDrops);
    const contractDrop = useSelector(state => state.contract.contractDrop);
    const contractsOutgoing = useSelector(state => state.contract.contractsOutgoing);
    const noOutgoingContractsExist = useSelector(state => state.contract.noOutgoingContractsExist);
    const project = useSelector(state => state.projects.project);
    const projects = useSelector(state => state.projects.projects);
    const projectDrop = useSelector(state => state.projects.projectDrop);
    const projectDrops = useSelector(state => state.projects.projectDrops);
    const noProjectsExist = useSelector(state => state.projects.noProjectsExist);
    const invoice = useSelector(state => state.invoices.invoice);
    const invoices = useSelector(state => state.invoices.invoices);
    const invoiceTabIncoming = useSelector(state => state.invoices.invoiceTabIncoming);
    const attachments = useSelector(state => state.invoices.invoice.attachments);
    const attachmentsAdditional = useSelector(state => state.invoices.invoice.attachments_additional);

    /*
    Enable users to create contract / project on the fly when creating invoice
    ** need backend fix: create contract = active (or get outgoing includes pending). Currently
    [useExistingProject, setUseExistingProject] = useState(true);
    [useExistingContract, setUseExistingContract] = useState(true);

    const newProjectInitital = {
        project_name: null,
        country: null,
        street: null,
        city: null,
    }
    const newContractInitial = {
        pid: null,
        company_creator_type: "Vendor",

        contract_name: null,

        up: true,
        PCA: "test1@purchaser.com"

    }
    handleInvoiceNewContract(newContract, invoice, )
    handleInvoiceNewProject(newProject, newContract, invoice, )
    */

    const emptyInvoiceDraft = {
        invoice_number: null,
        subtotal: null,
        taxes: null,
        total_value: null,
        description: null,
        po: null,
        contract_id: null,
        project_id: null
    }
    const [invoiceDraft, setInvoiceDraft] = useState(emptyInvoiceDraft)
    const [toView, setToView] = useState(false);
    const [creatingNewDraft, setCreatingNewDraft] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [selectedFilesInvoice, setSelectedFilesInvoice] = useState([]);
    const [selectedFilesInvoiceAdditional, setSelectedFilesInvoiceAdditional] = useState([]);
    const [removedFilesInvoice, setRemovedFilesInvoice] = useState([]);
    const [removedFilesInvoiceAdditional, setRemovedFilesInvoiceAdditional] = useState([]);
    const [deletionModalOpen, setDeletionModalOpen] = useState(false);
    const [reviewModalOpen, setReviewModalOpen] = useState(false);
    const [trashIsHovered, setTrashIsHovered] = useState(false);

    const auth = useSelector((state) => state.auth);

    const projectsPossible = projects.filter(project => project.project_status = "Active");
    // ** maybe don't filer projects because 1) not working 2) will be ablet to create wf on the fly
    const contractsPossible = invoiceDraft.project_id ? contractsOutgoing.filter(contract => contract.project_id === invoiceDraft.project_id) : contractsOutgoing;

    // used both to actually send (below) and to show the recipient/contract on
    // the review modal (GitHub #640) before that happens
    const invoiceContract = contractsOutgoing.filter(contract => contract.contract_id === invoiceDraft.contract_id)[0];
    const reviewProject = projectsPossible.filter(project => project.project_id === invoiceDraft.project_id)[0];

    // MOUNT OR REFRESH
    useEffect(() => {
        // GET OUTGOING CONTRACT LIST IF NOT ALREADY LOADED 
        props.getContractsOutgoing();
        return () => {
            props.clearContractsOutgoing();
        }
    }, []);


    // SET SELECTIONS PER DROPS (OR CLEAR DROPS IF NOT POSSIBLE)
    useEffect(() => {
        // when project & contract lists have been received, set selections and/or clear drops based on availability
        const projectCallComplete = noProjectsExist || projects.length > 0;
        const contractCallComplete = noOutgoingContractsExist || contractsOutgoing.length > 0;

        if (projectCallComplete && contractCallComplete) {
            if (contractDrop.contract_id) {
                const contractDropIsValid = contractsOutgoing.filter(contract => contract.contract_id === contractDrop.contract_id).length > 0;
                if (contractDropIsValid) {
                    setInvoiceDraft({...invoiceDraft, contract_id: contractDrop.contract_id, project_id: contractDrop.project_id});
                } else {
                    props.setContractDrop({});
                    const projectDropIsValid = projectsPossible.filter(project => project.project_id === projectDrop.project_id).length > 0;
                    if (projectDropIsValid) {
                        setInvoiceDraft({...invoiceDraft, project_id: projectDrop.project_id});
                    } else {
                        props.setProjectDrop({});
                    }
                }
            }
        }
    }, [contractsOutgoing, projects, noProjectsExist, noOutgoingContractsExist]);


    // WHEN INVOICE ARRIVES/UPDATES IN STORE
    useEffect(() => {
        // IF TRIGGERED BY SUBMIT, REROUTE
        if (toView) {
            props.handleReroute(`/mng/invoice/view/${invoice.invoice_id}`);
        // IF TRIGGERED BY PAGE LOAD, FILL FORM WITH INVOICE OR DROP INFO
        } else if (creatingNewDraft) {
            props.handleReroute(`/mng/invoice/edit/${invoice.invoice_id}`);
        } else {
            if (props.match.params.id === "new") {
                const defaultProject = projectsPossible.filter(project => project.project_id === projectDrop.project_id).length > 0 ? projectDrop.project_id : null;
                const defaultContract = contractsPossible.filter(contract => contract.contract_id === contractDrop.contract_id).length > 0 ? contractDrop.contract_id : null;
                setInvoiceDraft({...invoiceDraft, project_id: defaultProject, contract_id: defaultContract})
            } else if (props.match.params.id === invoice.invoice_id) {
                const { invoice_number, subtotal, taxes, total_value, invoice_description, po, contract_id, project_id } = invoice;
                setInvoiceDraft({invoice_number, subtotal, taxes, total_value, invoice_description, po, contract_id, project_id});
            }
        }
    }, [invoice]);



    // SELECT PROJECT FROM DROPDOWN
    const handleSelectProject = (e) => {
        const newProjectId = e.target.value === "" ? null : e.target.value;
        // only make changes if selection has changed
        if (newProjectId !== invoiceDraft.project_id) {
                setInvoiceDraft({...invoiceDraft, project_id: newProjectId, contract_id: null});
            if (newProjectId && newProjectId !== undefined) {
                // Set project selection, clear any selected contract, and set drops to match
                const newProjectDrop = projectDrops.filter(projectDrop => projectDrop.project_id === newProjectId)[0];
                projectDrop.project_id !== newProjectDrop.project_id && props.setProjectDrop(newProjectDrop);
                contractDrop.contract_id && props.setContractDrop({});
            } else {
                projectDrop.project_id && props.setProjectDrop({});
                contractDrop.contract_id && props.setContractDrop({});
            }

        }
    }

    // SELECT CONTRACT FROM DROPDOWN
    const handleSelectContract = (e) => {
        const newContractId = e.target.value === "" ? null : e.target.value;
        if (newContractId !== invoiceDraft.contract_id) {
            if (newContractId && newContractId !== undefined) {
                const newProjectId = contractsPossible.filter(contract => contract.contract_id === newContractId)[0].project_id;
                setInvoiceDraft({...invoiceDraft, project_id: newProjectId, contract_id: newContractId});
                const newProjectDrop = projectDrops.filter(projectDrop => projectDrop.project_id === newProjectId)[0];
                const newContractDrop = contractDrops.filter(contractDrop => contractDrop.contract_id === newContractId)[0];
                projectDrop.project_id !== newProjectDrop.project_id && props.setProjectDrop(newProjectDrop);
                contractDrop.contract_id !== newContractDrop.contract_id && props.setContractDrop(newContractDrop);
            } else {
                setInvoiceDraft({...invoiceDraft, contract_id: null});
                contractDrop.contract_id && props.setContractDrop({});
            }

        }
    }

    // ENTER FORM DATA
    const handleUpdateForm = (e) => {
        // when info is input into the form, add it to the local state. Ensure that empty inputs have a value of "", but corresponding state has a value of null
        if (e.target.value === "") {
            setInvoiceDraft({...invoiceDraft, [e.target.id]: null});
        } else {
            setInvoiceDraft({...invoiceDraft, [e.target.id]: e.target.value});
        }
    }

    const handleBlurCurrency = (e) => {
        let valueWithDecimals = parseFloat(e.target.value).toFixed(2);
        e.target.value === "" 
        ? setInvoiceDraft({...invoiceDraft, [e.target.id]: null})
        : setInvoiceDraft({...invoiceDraft, [e.target.id]: valueWithDecimals});
    }

    // UPDATE FORMS LOCALLY  ----------------------
    // set local state for removal of previously uploaded file
    const removeUploadedFileInvoice = (id) => { 
        setRemovedFilesInvoice(
            removedFilesInvoice => [...removedFilesInvoice, id]
        )
    }
    const removeUploadedFileAdditional = (id) => { 
        setRemovedFilesInvoiceAdditional(
            removedFilesInvoiceAdditional => [...removedFilesInvoiceAdditional, id]
        )
    }
    // remove unsaved file from local state
    const removeSelectedFileInvoice = (file_path) => { 
        setSelectedFilesInvoice(selectedFilesInvoice.filter((file) => file.path !== file_path));
    }
    const removeSelectedFileAdditional = (file_path) => { 
        setSelectedFilesInvoiceAdditional(selectedFilesInvoiceAdditional.filter((file) => file.path !== file_path));
    }
    // add new file to local state
    const handleDropInvoiceFile = (files) => { 
        files.map(file => {
            let file_exists = undefined;
            file_exists = selectedFilesInvoice.find( ({ path }) => path === file.path );
            if (file_exists == undefined) {
                setSelectedFilesInvoice(
                    selectedFilesInvoice => [...selectedFilesInvoice, file]
                )
            }
        });
    }
    const handleDropAdditionalFile = (files) => { 
        files.map(file => {
            let file_exists = undefined;
            file_exists = selectedFilesInvoiceAdditional.find( ({ path }) => path === file.path );
            if (file_exists == undefined) {
                setSelectedFilesInvoiceAdditional(
                    selectedFilesInvoiceAdditional => [...selectedFilesInvoiceAdditional, file]
                )
            }
        });
    }
    // ----------------------------------------------

    // append files in state to other form elements when it's time to save/send
    const populateFormAttachments = (formData) => {
        for ( var key in invoiceDraft ) {
            key !== "project_id" && formData.append(key, invoiceDraft[key]);
        }
        let file_counter = 1
        selectedFilesInvoice.map(file => {
            formData.append("initial-" + file_counter.toString(), file);
            file_counter++;
        });
        selectedFilesInvoiceAdditional.map(file => {
            formData.append("additional-" + file_counter.toString(), file);
            file_counter++;
        });
        removedFilesInvoice.map(file => {
            formData.append("remove_files[]", file);
        });
        removedFilesInvoiceAdditional.map(file => {
            formData.append("remove_files[]", file);
        });  
        return formData
    }

    // SAVE DRAFT (WITHOUT SENDING)
    const handleSave = (e) => {
        e.preventDefault();
        if (isSubmitting) return;
        setIsSubmitting(true);
        setCreatingNewDraft(true);
        // if a draft already exists, push to list on save. Otherwise, use return of id to trigger push to list
        let formData = new FormData();
        formData.append("invoice_status", "Draft");
        formData = populateFormAttachments(formData);
        formData.delete("project_id")
        console.log("aaa")
        const save = invoice.invoice_id
            ? props.editInvoiceDraft(invoice.invoice_id, formData)
            : props.createInvoiceDraft(formData);
        save.finally(() => setIsSubmitting(false));
    }

    // SEND INVOICE -- opens the review step (GitHub #640) instead of sending directly;
    // native required-field validation already ran by the time this fires, since it's
    // still the form's onSubmit
    const handleSend = (e) => {
        e.preventDefault();
        if (isSubmitting) return;
        setReviewModalOpen(true);
    }

    // actually sends the invoice -- called from the review modal's confirm button, not
    // directly from the form, so the user has a chance to look before this runs
    const submitInvoice = () => {
        // if invoice tab was set to incoming, toggle to outgoing so the user sees their newly created contract if they go back to list view
        if (isSubmitting) return;
        setIsSubmitting(true);
        setToView(true);
        // when sent: if the draft already exists, push to view by existing id. otherwise, prepare to capture the id once it has returned then push to view by id
        // if it's not a draft but a revision, updateInvoice stage instead of sending invoice
        let formData = new FormData();
        const purchaserName = invoice.company_purchaser?.name ? invoice.company_purchaser.name : "the Purchaser";
        const newPurchaserName = invoiceContract?.company_purchaser_name ? invoiceContract?.company_purchaser_name : "the Purchaser"
        let send;
        if (invoice.invoice_id ) {
            if (invoice.stage === "REJ") {
                formData.append("stage", "REV");
                formData = populateFormAttachments(formData);
                console.log("respondToInvoice")
                send = props.respondToInvoice(invoice.invoice_id, formData, `Revision sent to ${purchaserName}.`);

            } else {
                formData.append("invoice_status", "Pending");
                formData = populateFormAttachments(formData);
                console.log("sendSavedInvoice")
                send = props.sendSavedInvoice(invoice.invoice_id, formData, newPurchaserName);
            }
        } else {
            console.log("sendNewInvoice")
            formData.append("invoice_status", "Pending");
            formData = populateFormAttachments(formData)
            send = props.sendNewInvoice(formData, newPurchaserName);
        }
        send.finally(() => {
            setIsSubmitting(false);
            setReviewModalOpen(false);
        });
    }

    // DELETE DRAFT
    const handleDelete = () => {
        if (props.match.params.id === "new") {
            props.createMessage({success: "Invoice draft deleted"})
        } else {
            props.deleteInvoice(invoice.invoice_id, invoice.invoice_number)
        }
        props.handleReroute(`/mng/invoices/all`);
    }

    // downloads an already-saved attachment so it can be viewed -- used by the review
    // modal (GitHub #640), matching the pattern InvoiceView.js already uses for this
    const downloadReviewAttachment = (id, file_name) => {
        const fileDownload = require("js-file-download");
        axios.get(`/v0/api/core/download/${id}/`, {
            responseType: "blob",
            headers: { "Authorization": `Token ${auth.token}` }
        }).then(res => {
            fileDownload(res.data, file_name);
        }).catch(err => {
            console.log(err);
        });
    }

    // combines newly-selected (not yet uploaded) files with already-saved attachments,
    // for the review modal (GitHub #640) -- excludes anything the user has since removed
    const reviewOfficialFiles = [
        ...selectedFilesInvoice.map(file => ({ file })),
        ...(attachments || []).filter(a => !removedFilesInvoice.includes(a.id)).map(attachment => ({ attachment }))
    ];
    const reviewAdditionalFiles = [
        ...selectedFilesInvoiceAdditional.map(file => ({ file })),
        ...(attachmentsAdditional || []).filter(a => !removedFilesInvoiceAdditional.includes(a.id)).map(attachment => ({ attachment }))
    ];

    const projectSelect = (
        <div className="input-basic">										
            <select 
                name="project_id" 
                id="project_id" 
                required 
                style={invoiceDraft.project_id ? {color: "#3C3B41" } : {color: "#919197"}}
                onChange={(e) => handleSelectProject(e)}
                value={invoiceDraft.project_id === null ? "" : invoiceDraft.project_id}
                disabled={props.match.params.mode === "revise"}
                >
                <option value="" >Select an Active Project</option>
                {projectsPossible.map((project) => {
                    return <option key={project.project_id} value={project.project_id} >{project.project_name}</option>
                })}
            </select>
            <label htmlFor="project_id">Project<span> *</span></label>
        </div>
    )

    const contractSelect = (
        <div className="input-basic">										
            <select 
                name="contract_id" 
                id="contract_id" 
                required 
                style={invoiceDraft.contract_id ? {color: "#3C3B41" } : {color: "#919197"}}
                onChange={(e) => handleSelectContract(e)}
                value={invoiceDraft.contract_id ? invoiceDraft.contract_id : ""}
                disabled={props.match.params.mode === "revise"}
                >
                <option value="" >Select a Recipient</option>
                {contractsPossible.map((contract) => {
                    return <option key={contract.contract_id} value={contract.contract_id} >{contract.contract_name}</option>
                })}
            </select>
            <label htmlFor="contract_id">Contract<span> *</span></label>
        </div>
    )

    const invoiceTitle = (invoiceDraft.invoice_number ? invoiceDraft.invoice_number : "Untitled Draft") + (invoice.stage === "REJ" ? ` Version ${invoice.version + 1}` : "");

    return (
        <div className={auth ? "" : "flex-column center" }>
            {deletionModalOpen &&
            <ConfirmationModal handleClose={() => setDeletionModalOpen(false)} proceedButtonText="Delete Draft" onSubmit={handleDelete} >
                <div className="content1 multiline light-black gap-below-m">
                    <p className="gap-below-s">Are you sure you want to delete this invoice draft?</p>
                    <p className="heavy" >This step cannot be undone. Type "confirm" to proceed</p>
                </div>
            </ConfirmationModal>}
            {reviewModalOpen &&
            <InvoiceReviewModal
                handleClose={() => setReviewModalOpen(false)}
                onConfirm={submitInvoice}
                isSubmitting={isSubmitting}
                confirmLabel={invoice.stage === "REJ" ? "Send Revision" : "Send Invoice"}
                invoiceDraft={invoiceDraft}
                recipientName={invoiceContract?.company_purchaser_name}
                contractName={invoiceContract?.contract_name}
                projectName={reviewProject?.project_name}
                officialFiles={reviewOfficialFiles}
                additionalFiles={reviewAdditionalFiles}
                onDownloadAttachment={downloadReviewAttachment}
            />}
            <div className="invoice-card">
                <div className="single-header space-btwn">
                    <h1 className="title heavy iblock">Invoice&nbsp;<span className="light-black">{invoiceTitle}</span></h1>
                    {props.match.params.mode === "edit" &&
                    <div
                        onMouseEnter={() => setTrashIsHovered(true)}
                        onMouseLeave={() => setTrashIsHovered(false)}
                        onClick={() => setDeletionModalOpen(true)}
                    >
                        <IconTrash  height="22px" pathClass={trashIsHovered ? "p-fill" : "g7-fill" } className="td-icon gap-left-s"  style={{marginTop: "-2px"}} />  
                    </div>
                    }
                </div>

                <div className="invoice-container">
                    <form className="form gap-above-m" onSubmit={(e) => handleSend(e)}> 
                        <div className="inputs-wrapper">
                            { projectSelect }
                            { contractSelect }  
                            <div className="input-basic">										
                                <input
                                type="text"
                                name="invoice_number"
                                id="invoice_number"
                                placeholder="Invoice Number"	
                                value={invoiceDraft.invoice_number ? invoiceDraft.invoice_number : ""}
                                onChange={(event) => handleUpdateForm(event)}
                                required
                                disabled={invoice.stage === "REJ"}
                                />
                                <label htmlFor="invoice_number">Invoice #<span> *</span></label>
                            </div>
                            <div className="input-basic">										
                                <input
                                type="text"
                                name="po"
                                id="po"
                                placeholder="PO Number"	
                                value={invoiceDraft.po ? invoiceDraft.po : ""}
                                onChange={(event) => handleUpdateForm(event)}
                                />
                                <label htmlFor="po">PO #</label>
                            </div>
                            <div className="input-basic">										
                                <input
                                type="number"
                                name="subtotal"
                                id="subtotal"
                                placeholder="0.00"	
                                onBlur={(event) => handleBlurCurrency(event)}
                                step=".01"
                                min="0"
                                value={invoiceDraft.subtotal ? invoiceDraft.subtotal : ""}
                                onChange={(event) => handleUpdateForm(event)}
                                />

                                <label htmlFor="subtotal">Subtotal</label>
                            </div>
                            <div className="input-basic">
                                <input
                                type="number"
                                name="taxes"
                                id="taxes"
                                placeholder="0.00"	
                                onBlur={(event) => handleBlurCurrency(event)}
                                step=".01"
                                min="0"
                                value={invoiceDraft.taxes ? invoiceDraft.taxes : ""}
                                onChange={(event) => handleUpdateForm(event)}
                                />
                                <label htmlFor="taxes">Taxes</label>
                            </div>
                            <div className="input-basic">										
                                <input
                                type="number"
                                name="total_value"
                                id="total_value"
                                placeholder="0.00"	
                                onBlur={(event) => handleBlurCurrency(event)}
                                step=".01"
                                min="0"
                                value={invoiceDraft.total_value ? invoiceDraft.total_value : ""}
                                onChange={(event) => handleUpdateForm(event)}
                                required
                                />
                                <label htmlFor="total_value">Final Total<span> *</span></label>
                            </div>
                            <div className="input-basic textarea addspace">	
                                <label className="textarea" htmlFor="invoice_description">Description</label>			
                                <textarea 
                                    type="text" 
                                    name="invoice_description" 
                                    id="invoice_description" 
                                    rows="3"
                                    value={invoiceDraft.invoice_description ? invoiceDraft.invoice_description : ""}
                                    onChange={(event) => handleUpdateForm(event)}
                                />
                            </div>
                        </div> 
                        <div className="gap-above-l">
                            <p className="content2 heavy-grey gap-below-xs">Official Invoice</p>
                            <Addfiles 
                                uploadTitle="+ Add Official Invoice"
                                attachments={attachments} 
                                selectedFiles={selectedFilesInvoice}
                                handleDrop={handleDropInvoiceFile}
                                removeSelectedFile={removeSelectedFileInvoice}
                                removeUploadedFile={removeUploadedFileInvoice}
                                removedFiles={removedFilesInvoice}
                                maxSize={10485760}
                                maxFiles={0}
                                multiple={false}
                                accept={ALLOWED_ATTACHMENT_TYPES}
                            />
                        </div>

                        <div className="gap-above-m">
                            <p className="content2 heavy-grey gap-below-xs">Supporting Documents</p>
                            <Addfiles 
                                uploadTitle="+ Add Supporting Docs"
                                attachments={attachmentsAdditional}
                                selectedFiles={selectedFilesInvoiceAdditional}
                                handleDrop={handleDropAdditionalFile}
                                removeSelectedFile={removeSelectedFileAdditional}
                                removeUploadedFile={removeUploadedFileAdditional}
                                removedFiles={removedFilesInvoiceAdditional}
                                maxSize={10485760}
                                maxFiles={0}
                                multiple={true}
                                accept={ALLOWED_ATTACHMENT_TYPES}
                            />
                        </div>
                        <div className="flex-row" style={{justifyContent: "flex-end"}}>

                            {props.match.params.mode === "edit" &&
                            <button className="btn min-width sec gap-right-s" disabled={invoiceDraft.contract_id === null || isSubmitting} onClick={(e) => handleSave(e)}>Save Draft</button> }
                            {props.match.params.mode === "revise" &&
                            <button className="btn min-width sec gap-right-s" onClick={() => props.handleReroute(`/mng/invoices/all`)}>Cancel</button> }
                            <button id="send_invoice" type="submit" className="btn pri" disabled={isSubmitting}>{isSubmitting ? "Sending..." : (props.match.params.mode === "revise" ? "Send Revision" : "Send Invoice")}</button>

                        </div>
                    </form>
                </div>         
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, { 
    logout, 
    getProjects, 
    clearProject, 
    uploadFileAttachment, 
    clearInvoice, 
    editContractAttachment, 
    getInvoiceWithoutAttachments, 
    getContractsOutgoing, 
    sendNewInvoice, 
    toggleInvoiceTab, 
    createInvoiceDraft, 
    sendSavedInvoice, 
    editInvoiceDraft, 
    getInvoice, 
    respondToInvoice, 
    clearInvoiceAttachments,
    getContractDrops,
    setContractDrop,
    setProjectDrop,
    clearContractsOutgoing,
    deleteInvoice,
    createMessage
 })(InvoiceEdit);

